import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  modal1: {
    open: false,
    rowData: [],
    selected: [],
    changed: [],
  },
  modal2: {
    open: false,
    rowData: [],
    selected: [],
    changed: [],
  },
  modal3: {
    open: false,
    rowData: [],
    selected: [],
    changed: [],
  },
  modal4: {
    open: false,
    rowData: [],
    selected: [],
    changed: [],
  },
  modal5: {
    open: false,
    rowData: [],
    selected: [],
    changed: [],
  },
  modal6: {
    open: false,
    rowData: [],
    selected: [],
    changed: [],
  },
  modal7: {
    open: false,
    rowData: [],
    selected: [],
    changed: [],
  },
};

const ModalSlice = createSlice({
  name: 'Modal',
  initialState,
  reducers: {
    openModal: (state, action) => {
      const modalId = action.payload;
      if (state[modalId]) {
        state[modalId].open = true;
      }
    },
    closeModal: (state, action) => {
      const modalId = action.payload;
      if (state[modalId]) {
        state[modalId].open = false;
      }
    },
    setModalRows: (state, action) => {
      const { modalId, rowData } = action.payload;
      if (state[modalId]) {
        state[modalId].rowData = rowData;
      }
    },
    setModalSelected: (state, action) => {
      const { modalId, selected } = action.payload;
      if (state[modalId]) {
        state[modalId].selected = selected;
      }
    },
    setModalChanged: (state, action) => {
      const { modalId, changed } = action.payload;
      if (state[modalId]) {
        state[modalId].changed = changed;
      }
    },
  },
});

export const {
  openModal,
  closeModal,
  setModalRows,
  setModalSelected,
  setModalChanged,
} = ModalSlice.actions;

export default ModalSlice.reducer;
